import { useMemo } from 'react';
import MinorResultHorizontalDiagram from './MinorResultHorizontalDiagram';
import MinorResultPieDiagram from './MinorResultPieDiagram';
import { useResultDiagramSectionStyles } from './ResultDiagramSection.styles';

type ResultDiagramSectionProps = {
  userResponse: any;
  variables: any[];
  diagramId?: number;
  isSimplePie: boolean;
  sendDataMax: (data: any) => void;
  diagramTitle?: string;
};

const ResultDiagramSection = ({
  userResponse,
  variables,
  diagramId,
  isSimplePie,
  sendDataMax,
  diagramTitle,
}: ResultDiagramSectionProps) => {
  const classes = useResultDiagramSectionStyles();

  const diagram = useMemo(() => {
    if (!userResponse) {
      return null;
    }

    if (isSimplePie || diagramId === 2) {
      return (
        <MinorResultPieDiagram
          userResponse={userResponse}
          sendDataMax={sendDataMax}
          isSimplePie={isSimplePie}
        />
      );
    }

    if ([3, 5].includes(diagramId || 0)) {
      return (
        <MinorResultHorizontalDiagram
          variables={variables}
          userResponse={userResponse}
          diagramId={diagramId || 3}
          sendDataMax={sendDataMax}
        />
      );
    }

    return null;
  }, [userResponse, variables, diagramId, isSimplePie, sendDataMax]);

  if (!diagram) {
    return null;
  }

  const isPieLayout = isSimplePie || diagramId === 2;

  return (
    <section className={classes.diagramSection}>
      {diagramTitle && !isSimplePie && <h2 className={classes.diagramTitle}>{diagramTitle}</h2>}
      <div className={classes.diagramWrap}>
        <div className={isPieLayout ? classes.pieChartWrap : undefined}>{diagram}</div>
      </div>
    </section>
  );
};

export default ResultDiagramSection;
